import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The parent's profile. `parent` coexists with no other facet: whoever is a guardian enters
// as a guardian, and an account that holds no profile at all is a parent with no children.
export const myParentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/me/parent',
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['parent'],
      currentPath: location.href,
    }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/my-parent.tsx')),
})
